import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Row, Col, Card, Breadcrumb, Descriptions } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { getDestinataire } from './destinataire.reducer';
import { TextFormat } from 'react-jhipster';
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';

export const NotificationDetails = (props: RouteComponentProps<{ ecoleid: string; id: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getDestinataire(props.match.params.id));
  }, []);

  const currentEcole = useAppSelector(state => state.ecole.entity);
  const destinataire = useAppSelector(state => state.destinataire.entity);
  const anneeScolaireId = props.match.params.anneeScolaireId;

  const { match } = props;
  return (
    <>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item>
          <Link to={`/home/${currentEcole && currentEcole.id}/${anneeScolaireId}`}>{currentEcole && currentEcole.nom}</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/notification/${currentEcole && currentEcole.id}/${anneeScolaireId}`}>Messages</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Details</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      {destinataire.id !== null && (
        <Card>
          <Row className="justify-content-center">
            <h2>KoriSchool</h2>
          </Row>
          <span>
            <Descriptions column={1}>
              <Descriptions.Item label="Destinataires">
                {destinataire.eleveMatricule ? (
                  <>
                    {' '}
                    Parent de l&apos;élève matricule &nbsp; <b> {destinataire.eleveMatricule} </b>{' '}
                  </>
                ) : (
                  <>
                    Tous les élèves {destinataire.etatPaiement ? destinataire.etatPaiement + ' ' : ''}
                    {destinataire.statutPresence ? destinataire.statutPresence + ' ' : ''}
                    {destinataire.classes && destinataire.classes.length > 0
                      ? destinataire.classes.length === 1
                        ? ` de la classe de ${destinataire.classes[0].nom}`
                        : ` des classes ${destinataire.classes.map(c => c.nom).join(', ')}`
                      : ''}
                  </>
                )}
              </Descriptions.Item>
            </Descriptions>
          </span>
          <Row className="justify-content-center">
            <Col lg={{ span: 16 }} xs={{ span: 14 }} sm={{ span: 16 }} md={{ span: 16 }}>
              <span>{destinataire.message}</span>
            </Col>
          </Row>
          <Row className="justify-content-end">
            <span>
              {' '}
              Envoyé le&nbsp;
              <TextFormat type="date" value={destinataire.createdDate} format={APP_TIMESTAMP_FORMAT} />{' '}
            </span>
          </Row>
        </Card>
      )}
    </>
  );
};
export default NotificationDetails;
